export default {
  model: [
    {
      label: 'Nome',
      field: 'name',
      type: 'text'
    },
    {
      label: 'Email',
      field: 'email',
      type: 'email'
    },
    {
      label: 'Celular',
      field: 'cellphone',
      type: 'text'
    },
    {
      label: 'Revistas de interesse',
      field: 'interested_magazines',
      type: 'array'
    }
  ]
}